/**
 * THE GROCER'S OWN DOOR PATTERN, BEHIND EVERYTHING.
 *
 * One fixed layer, the finished tile exactly as supplied, repeating at
 * 360x480. No animation, no pointer events, and no `background-attachment:
 * fixed` — that one judders and tears on iOS Safari, so the layer itself is
 * fixed instead and the page scrolls over it.
 *
 * Only the organisation whose setting says so gets it. Everyone else, and the
 * portal, is untouched.
 */
import { useEffect, useState } from 'react';

const TILES = {
    day: '/sobeys/sobeys-door-pattern-day.png',
    night: '/sobeys/sobeys-door-pattern-night.png',
};

export const BrandPattern = ({ pattern }) => {
    const [dark, setDark] = useState(
        () => document.documentElement.classList.contains('dark'));

    useEffect(() => {
        const el = document.documentElement;
        const read = () => setDark(el.classList.contains('dark'));
        const obs = new MutationObserver(read);
        obs.observe(el, { attributes: true, attributeFilter: ['class'] });
        read();
        return () => obs.disconnect();
    }, []);

    if (!pattern || pattern.enabled === false) return null;
    const src = dark ? TILES.night : TILES.day;
    // One opacity token per mode, default HALF strength, so the grocer's
    // pattern stays a backdrop and never competes with the list.
    const opacity = Number(
        (dark ? pattern.opacity_dark : pattern.opacity_light) ?? 0.5);

    return (
        <div aria-hidden="true" data-testid="grocery-brand-pattern"
            data-mode={dark ? 'night' : 'day'}
            data-strength={Number.isFinite(opacity) ? opacity : 0.5}
            style={{
                position: 'fixed', inset: 0, zIndex: 0, pointerEvents: 'none',
                backgroundImage: `url(${src})`,
                backgroundRepeat: 'repeat',
                backgroundSize: '360px 480px',
                opacity: Number.isFinite(opacity) ? opacity : 0.5,
            }} />
    );
};

export default BrandPattern;
